import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'FacetFilter' })({
    select: {
        textAlign: 'end'
    },
    key: {
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '16px',
        flex: 1
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: 16
    },
    count: {
        color: '#8E8E8E',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '16px'
    },
    chip: {
        color: '#232323',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
        padding: '0 8px',
        borderRadius: 96,
        background: '#F8F8F8'
    }
});
